import React from 'react'
import Layout from '../Layout'
import DashboardHeader from '../DashboardHeader'
import CartComponent from '../../../utils/CommonFunctionality/Cart'

const Cart = (props) => {
    return (
        <Layout props={props}>
            {/* <DashboardHeader /> */}
            <div className="lq-db-table">
                <CartComponent props={props} />
            </div>
        </Layout>
    )
}

export default Cart
